import React from 'react'
import GeoentityBlocks from './blocks/GeoentityBlocks'
import GeoentitySuggestChange from './GeoentitySuggestChange'
import GeoentityMorePois from './GeoentityMorePois'
import s from './GeoentityCardMain.less'
import { AdDesktopRectangleGeoentity } from '../advertising/InlineDesktopAdBanner'
import { AdMobileBannerGeoentity } from '../advertising/InlineMobileAdBanner'
import {
  selectCurrentGeoentityId,
  selectHasSelectedGeoentityFullContent,
  selectGeoentityError
} from '../../store/geoentity/geoentity.selectors'
import { useSelector } from 'react-redux'
import NPSSurvey from '../survey/NPSSurvey'
import GeoentityCardMainPlaceholder from './GeoentityCardMainPlaceholder'
import GeoentitySourcePj from './GeoentitySourcePj'
import GeoentityContactInfoButtons from './contactInfo/GeoentityContactInfoButtons'
import { isPE } from '../Device'
import GeoentityAdVideo from './GeoentityAdVideo'
import GeoentityCardButtons from './blocks/GeoentityCardButtons'
import SharePoiPopin from '../itinerary/shareToMobile/SharePoiPopin'

const GeoentityCardMain = () => {
  const geoentityId = useSelector(selectCurrentGeoentityId)
  const fullContentLoaded = useSelector(selectHasSelectedGeoentityFullContent)
  const error = useSelector(selectGeoentityError)

  if (error || !geoentityId) return null

  if (!fullContentLoaded) return <GeoentityCardMainPlaceholder />

  return (
    <div className={s.root}>
      {isPE() && (
        <>
          <div className={s.contactInfoButtons}>
            <GeoentityContactInfoButtons />
          </div>
        </>
      )}
      <div className={s.mainContent}>
        <GeoentityCardButtons />
        <GeoentityBlocks />
        <AdDesktopRectangleGeoentity key={`AdDesktop-${geoentityId}`} />
        <AdMobileBannerGeoentity key={`AdMobile-${geoentityId}`} />
        <GeoentityMorePois />
        <GeoentitySuggestChange />
        <GeoentitySourcePj />
        <NPSSurvey />
        <GeoentityAdVideo />
        <SharePoiPopin />
      </div>
    </div>
  )
}

export default GeoentityCardMain
